import appConfig from '@/config.js'

let loading = null

export function loadMoovaChat() {
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `${appConfig.integrations.moovaChat.url}/loader.js`
      script.async = true
      script.onload = () => resolve(window.MoovaChat)
      script.onerror = () => {
        // Otherwise a network failure would keep the rejected promise cached forever.
        loading = null
        script.remove()
        reject(new Error('MoovaChat loader failed to load'))
      }
      document.head.appendChild(script)
    })
  }
  return loading
}
